import { ThemeEvents } from '@theme/events';

/**
 * Keeps the continuative-product restock message aligned with the selected variant.
 * Shopify updates the purchase button after a variant change, while this message
 * lives outside the portion of the form that the theme morphs automatically.
 */
document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const productId = String(event.detail?.data?.productId || '');
  const variant = event.detail?.resource;
  const shouldShow = Boolean(variant && variant.available === false);

  document.querySelectorAll('[data-product-restock-note]').forEach((note) => {
    if (!(note instanceof HTMLElement)) return;
    if (productId && note.dataset.productId !== productId) return;

    note.hidden = !shouldShow;
  });
});
